import React from 'react';
import { getMcpBuiltinServerByToolName, MCP_BUILTIN_SERVER_KEY } from '@kentik/ui-shared/kaizen/mcpBuiltinServers';
import { Flex, Icon, Text } from 'core/components';
import { InfobloxLogo } from 'app/components/InfobloxLogo';
import { getAgentDisplayName } from '../util/agentDisplayNames';

// Which MCP server a tool call went to; native integrations carry their own branding.
const McpServerLabel = ({ toolName }) => {
  const builtin = getMcpBuiltinServerByToolName(toolName);

  if (builtin?.key === MCP_BUILTIN_SERVER_KEY.INFOBLOX_IQ) {
    return (
      <Flex alignItems="center" gap="4px" ml={1}>
        <InfobloxLogo size={18} />
        <Text small>{builtin.displayName}</Text>
      </Flex>
    );
  }

  return (
    <Flex alignItems="center" gap="4px" ml={1} minWidth={0} maxWidth="40%">
      <Icon icon="data-connection" size={14} color="muted" style={{ flexShrink: 0 }} />
      <Text small muted ellipsis title={getAgentDisplayName(toolName)}>
        {getAgentDisplayName(toolName)}
      </Text>
    </Flex>
  );
};

export default McpServerLabel;
